import { __decorate } from "tslib";
import { Component, Vue } from 'vue-property-decorator';
let WhiteSpaceCheckerMixin = class WhiteSpaceCheckerMixin extends Vue {
    get trailingWhitespace() {
        return (value) => {
            const hasTrailingWhitespace = value.trim() !== value;
            return hasTrailingWhitespace;
        };
    }
    get whiteSpaceErrorMsgBuilder() {
        return (value) => {
            return `Invalid input. Please make sure that there are no whitespaces before or after the ${value} provided`;
        };
    }
};
WhiteSpaceCheckerMixin = __decorate([
    Component
], WhiteSpaceCheckerMixin);
export default WhiteSpaceCheckerMixin;
